const ThemeColors = {
  primaryColor: { '50': '#FDC9D9', '100': '#DD235B', '200': '#C7194D' },
  secondaryColor: { '100': '#F05586' }
};

export default ThemeColors;
